// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import store from './store/'
import mint from '@/library/mint'
import axios from 'axios'
import lrz from 'lrz'  //图片懒加载
import websocket from './utils/websocket.js'
import './assets/css/my-mint.styl';//全局修改mint-UI样式
import {Lazyload,Toast} from 'mint-ui'
//import VueAliplayerV2 from 'vue-aliplayer-v2';
import {mapGetters,mapActions} from 'vuex'
import VueWorker from 'vue-worker'
//加载必须要的core，demo简化起见采用的直接加载类库，实际使用时应当采用异步按需加载
import Import_Recorder from 'recorder-core'
//需要使用到的音频格式编码引擎的js文件统统加载进来
import 'recorder-core/src/engine/mp3'
import 'recorder-core/src/engine/mp3-engine'
//可选的扩展
import 'recorder-core/src/extensions/waveview'
import {imageIsExist} from './utils/utils.js';
//import { plusReady } from '@/assets/js/date.js';
Vue.use(VueWorker)
Vue.use(Lazyload);
Vue.use(VueAwesomeSwiper)
//Vue.use(VueAliplayerV2);
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.lrz = lrz
Vue.prototype.websocket = websocket
/*import APIJS from './assets/js/api.js'
Vue.prototype.api = APIJS*/
import UtilJS from './assets/js/util.js'
import {IndexList, IndexSection } from 'mint-ui';
Vue.prototype.util = UtilJS
//引入vant

//import {plusReady} from './assets/js/util.js';
/* eslint-disable no-new */
var _selff = '';
import ElementUI from 'element-ui';
Vue.use(ElementUI);

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

Vue.config.ignoredElements.push('wx-open-launch-weapp')

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) {
  let imgURL = binding.value;//获取图片地址
  let defaultURL = el.getAttribute('default-img');//获取默认图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute('src', imgURL);
    } else {
      if (defaultURL) {
        //alert("图片不存在默认路径"+defaultURL);
        //el.setAttribute('src', defaultURL);
      }
    }
  }
});
Vue.component(IndexList.name, IndexList);
Vue.component(IndexSection.name, IndexSection);
import { Radio } from 'mint-ui';
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
import wx from 'weixin-js-sdk'
axios.defaults.baseURL = 'https://www.hainanqz.cn/qzApp/';
//axios.defaults.baseURL = 'http://www.hainanqz.cn/qzApp/';
//axios.defaults.baseURL = 'http://localhost:8085/';
Vue.component(Radio.name, Radio);
let vm = new Vue({
  el: '#app',
  router,
  store,
  mint,
  template: '<App/>',
  components: { App },
  mounted(){
    let _self = this;
    let num = 0; //大于等于2则退出
    //let plusReady = UtilJS.plusReady;

    //微信js验证
    //this.url = "http://8.134.212.221:8081/changeUserInfo";
    this.url = (window.location.href).split('#')[0];
    const qs = require('qs');
    this.axios.post('wechat/getWxJSConfig',qs.stringify({url:this.url}))
      .then((response)=>{
        var data = response.data;
        var code = data.code;
        if(0 == code){
          let bdata = data.data;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来,测试完成后需要关闭。
            appId: bdata.appId, // 必填，公众号的唯一标识
            timestamp: bdata.timestamp, // 必填，生成签名的时间戳
            nonceStr: bdata.nonceStr, // 必填，生成签名的随机串
            signature: bdata.signature,// 必填，签名（加密后，下文有实现）
            jsApiList: [
              "checkJsApi",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "onMenuShareWeibo",
              "onMenuShareQZone",
              "hideMenuItems",
              "showMenuItems",
              "hideAllNonBaseMenuItem",
              "showAllNonBaseMenuItem",
              "translateVoice",
              "startRecord",
              "stopRecord",
              "onVoiceRecordEnd",
              "playVoice",
              "onVoicePlayEnd",
              "pauseVoice",
              "stopVoice",
              "uploadVoice",
              "downloadVoice",
              "chooseImage",
              "previewImage",
              "uploadImage",
              "downloadImage",
              "getNetworkType",
              "openLocation",
              "getLocation",
              "hideOptionMenu",
              "showOptionMenu",
              "closeWindow",
              "scanQRCode",
              "chooseWXPay",
              "openProductSpecificView",
              "addCard",
              "chooseCard",
              "openCard"], // 必填，需要使用的JS接口列表，开发文档上有所有接口名称，根据需要选用就好。
            openTagList:[
              "wx-open-launch-weapp"
            ] // 打开小程序
          });
        }
      }).catch(function (error) {
      var reg = RegExp(/Network Error/);
      if(reg.test(error)){
        Toast("网络不可用！请设置网络");
      }
    })


    /*vm.city = window.localStorage.getItem('currAddr');
    if(null == vm.city || ''==vm.city){*/

      wx.ready(function(){
        //是否允许公众号获取地理位置是一次性的;
        var GLat;
        var GLng;
        var GProvince;
        var GCity;
        var GDistrict;
        wx.getLocation({
          type: 'gcj02', //wgs84 或 gcj02
          success: function (res) {
            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。

            GLat = latitude;       //将纬度赋值给全局参数
            GLng = longitude;      //将经度赋值给全局参数


            var LATLNG_MJKD = longitude + ',' + latitude;  //调用百度转换接口时所需的参数;

            //将js-sdk转换为百度坐标
            var urlgetbd = 'http://api.map.baidu.com/geoconv/v1/';
            var lng;
            var lat;
            _self.$jsonp('https://api.map.baidu.com/geoconv/v1/?coords='+LATLNG_MJKD+'&from=1&to=5&ak=AEKqaL5hxbXaVkKQdXdyg3zIgKrK82kd')
              .then((response)=>{
                if (response.status == 0) {
                  lng = response.result[0].x;//经度
                  lat = response.result[0].y;//纬度
                  var MJKD_LATLNG = lat + ',' + lng;     //调用百度地图接口时所需的参数;

                  //var url = 'http://api.map.baidu.com/geocoder/v2/?ak=AEKqaL5hxbXaVkKQdXdyg3zIgKrK82kd&callback=renderReverse&location=' + MJKD_LATLNG + '&output=json&pois=1';
                  _self.$jsonp('https://api.map.baidu.com/reverse_geocoding/v3/?ak=AEKqaL5hxbXaVkKQdXdyg3zIgKrK82kd&output=json&coordtype=wgs84ll&location='+MJKD_LATLNG)
                    .then((response) => {
                      if (response.status == 0) {
                        //alert("经纬度："+ GLat +"，"+ GLng + data.result.addressComponent.province + data.result.addressComponent.city + data.result.addressComponent.district);

                        var province = response.result.addressComponent.province;      //省名
                        var city = response.result.addressComponent.city;              //城市名
                        var district = response.result.addressComponent.district;      //区县名

                        window.localStorage.setItem('currAddr',city)
                        _self.$store.dispatch('setLat', lng)
                        window.localStorage.setItem('lat',lng.toString())
                        _self.$store.dispatch('setLgt', lat)
                        window.localStorage.setItem('lgt',lat.toString())
                        window.localStorage.setItem('oldCurrAddr',city);
                        //将获取到的参数传到MVC控制台方法中,

                      }
                    }).catch(function (error) {
                    var reg = RegExp(/Network Error/);
                    if (reg.test(error)) {
                      Toast("网络不可用！请设置网络");
                    }
                  })
                }
              }).catch(function (error) {
              var reg = RegExp(/Network Error/);
              if(reg.test(error)){
                Toast("网络不可用！请设置网络");
              }
            })
          },
          fail: function (res) {
            /*alert('获取位置失败，请设置GPS定位');*/
          }
        });
      });

    /*}else{

      window.localStorage.setItem('currAddr','广州');
      vm.city = window.localStorage.getItem('currAddr');
    }*/


    if(window.plus){
        plus.push.addEventListener( "click", function(msg){
          let payload = msg.payload;
          let type = JSON.parse(payload).type;
          if("coupon" == type){
            _self.$store.dispatch('setCurindex', 4)
            _self.$router.push({path:'myMessage'})
          }
          clearAllPush();
        },false );
        function clearAllPush(){
          plus.push.clear();
        }
        var webview = plus.webview.currentWebview();
        plus.navigator.setFullscreen(false);
        // Android处理返回键
        window.IsSureQuit = false
        plus.key.addEventListener("backbutton",function (e) {
          webview.canBack(function(e) {
            if(e.canBack) {
              webview.back();
            } else {
              if(!num){
                num = new Date().getTime();
                Toast('再按一次退出应用');
                setTimeout(function() {
                  num = null;
                }, 1000);
              }else{
                if (new Date().getTime() - num < 1000) {
                  _self.$store.dispatch('setCurrAddr',null);
                  plus.runtime.quit();
                }
            }
              /*// 转入后台运行 注：IOS无效
              var main = plus.android.runtimeMainActivity();
              main.moveTaskToBack(false);*/
            }
          })
        },false);
    }else{
      document.addEventListener("plusready",function () {
        plus.push.addEventListener( "click", function(msg){
          let payload = msg.payload;
          let type = JSON.parse(payload).type;
          if("coupon" == type){
            _self.$store.dispatch('setCurindex', 4)
            _self.$router.push({path:'myMessage'})
          }
          clearAllPush();
        },false );
        function clearAllPush(){
          plus.push.clear();
        }
        var webview = plus.webview.currentWebview();
        plus.navigator.setFullscreen(false);
        // Android处理返回键
        window.IsSureQuit = false
        plus.key.addEventListener("backbutton",function (e) {
          webview.canBack(function(e) {
            if(e.canBack) {
              webview.back();
            } else {
              if(!num){
                num = new Date().getTime();
                Toast('再按一次退出应用');
                setTimeout(function() {
                  num = null;
                }, 1000);
              }else{
                if (new Date().getTime() - num < 1000) {
                  plus.runtime.quit();
                }
              }
              /*// 转入后台运行 注：IOS无效
              var main = plus.android.runtimeMainActivity();
              main.moveTaskToBack(false);*/
            }
          })
        },false);
      },false);
    }

  }
})

console.log(vm)




// WEBPACK FOOTER //
// ./src/main.js